import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import Moment from 'moment';
import { Auth } from 'aws-amplify';

import './App.css';

import Config from './Config';
import { FetchConfig } from "./helpers/ConfigApi";
import { useInterval } from "./hooks/useInterval";

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

import Routes from "./Routes";
import Banner from './components/layout/Banner';
import Footer from './components/layout/Footer';
import Loading from "./containers/Loading";



const App = (props) => {
  const [user, setUser] = useState();
  const [isInitialising, setIsInitialising] = useState(true);
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [message, setMessage] = useState("Loading ... ");
  const [config, setConfig] = useState();
  const history = useHistory();

  useEffect(() => {
    // refresh token
    Auth.currentSession()
    .then(data => console.log(data))
    .catch(err => console.log(err));

    // look for logged in user
    Auth.currentAuthenticatedUser()
    .then(user => {
      console.log(user);
      setUser(user);
      userHasAuthenticated(true);
    })
    .catch(err => console.log(err));
  }, []);

  useEffect(() => {
    const url = Config.URL_CONFIG + '?v=' + new Date().getTime();
    FetchConfig(url).then((newConfig) => {
      if (newConfig) {
        const updatedConfig = updateConfig(newConfig);
        console.log(updatedConfig);
        setConfig(updatedConfig);
        setIsInitialising(false);
      }
    })
      .catch(e => { console.log(e); setMessage(e); });
  }, []);

  useInterval(() => {
    const url = Config.URL_CONFIG + '?v=' + new Date().getTime();
    FetchConfig(url).then((newConfig) => {
      if (newConfig) {
        const updatedConfig = updateConfig(newConfig);
        setConfig(updatedConfig);
        setIsInitialising(false);
      }
    })
      .catch(e => { console.log(e); setMessage(e); });
  }, 60000);

  const updateConfig = (config) => {
    for (let i = 0; i < config.days.length; i++) {
      const day = config.days[i];
      for (let j = 0; j < day.sessions.length; j++) {
        const session = day.sessions[j];
        for (let k = 0; k < session.rooms.length; k++) {
          const room = session.rooms[k];
          for (let l = 0; l < room.events.length; l++) {
            const event = room.events[l];
            event.videoTitle = event.title;
            event.isLive = false;
            event.isVoD = false;
            event.isPending = false;
            const startDate = Moment(event.startDate).valueOf();
            const endDate = Moment(event.endDate).valueOf();
            const now = new Date().getTime();
            if ((startDate <= now) && (now < endDate)) {
              event.videoUrl = room.liveStream.videoUrl;
              event.videoId = room.liveStream.videoId;
              event.videoTitle = room.liveStream.videoTitle;
              event.isLive = true;
            }
            else if (event.videoUrl && (event.videoUrl.endsWith('.mp4') || event.videoUrl.endsWith('.m3u8'))) {
              event.isVoD = true;
            }
            else if (endDate < now) {
              event.isPending = true;
            }
          }
        }
      }
    }
    return config;
  }

  const Logout = () => {
    Auth.signOut().then(() => {
      userHasAuthenticated(false);
      setUser();
      history.push('/login');
    })
    .catch(e => console.log(e.message));
  };

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: '#31a9e0'
      }
    }
  },
  )

  return (
    <div className="App">
      <CssBaseline />
      <MuiThemeProvider theme={theme}>
        <Banner isAuthenticated={isAuthenticated} Logout={Logout} />
        <div className="body-content">
          <Container>
            <div className="body-container">
              {isInitialising && (
                <Loading message={message} />
              )}
              {!isInitialising && (
                <Routes appProps={{ isAuthenticated, userHasAuthenticated, setUser, user, config }} />
              )}
            </div>
          </Container>
          <Footer />
        </div>
      </MuiThemeProvider>
    </div>
  );
};

export default App;